import CryptoJS from './crypto-js.js'

export function getUrl(oldUrl) {
  let result1 = decodeURIComponent(oldUrl);
  if (result1.indexOf('http') > -1 ) {
    return result1
  }
  let options = {
    iv: CryptoJS.enc.Utf8.parse("6c031d737fba7fcf"),
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  }
  let key = key = CryptoJS.enc.Utf8.parse("d77ab88a8400ed08");
  let decryptedData = CryptoJS.AES.decrypt(result1, key, options);
  var decryptedStr = decryptedData.toString(CryptoJS.enc.Utf8);
  return decryptedStr;
}


// WEBPACK FOOTER //
// ./src/utils/deciphering.js